var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSeries = function SvgSeries(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 2.128a.376.376 0 0 0-.375.374v9c0 .207.169.375.375.375h6a.376.376 0 0 0 .375-.375v-9a.376.376 0 0 0-.375-.374zm-1.5.374c0-.827.673-1.5 1.5-1.5h6c.827 0 1.5.673 1.5 1.5v9c0 .828-.673 1.5-1.5 1.5h-6c-.827 0-1.5-.672-1.5-1.5zM2.5 2.69c0-.312.25-.562.563-.562.311 0 .562.25.562.562v8.625a.561.561 0 1 1-1.125 0zM.25 3.815c0-.312.25-.562.563-.562.311 0 .562.25.562.562v6.375a.561.561 0 1 1-1.125 0z"
  })));
};
export default SvgSeries;